/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleListSortCriteria {
    getFixupPrototypeFunction() { return ScheduleListSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ScheduleListSortCriteria>): ScheduleListSortCriteria {
        let obj = Object.assign(new ScheduleListSortCriteria(), model);
        ScheduleListSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleListSortCriteria>): ScheduleListSortCriteria {
        if (!model) return null;
        return ScheduleListSortCriteria.newInstance(<ScheduleListSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleListSortCriteria) {
        if (!obj) return;

        models.ScheduleListSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleListSortCriteria): boolean {
        Object.setPrototypeOf(obj, ScheduleListSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ScheduleListSortColumn;

    ascending: boolean;

}
